export default "__VITE_ASSET__Dq6c7ldb__"